@if (linkableItems$ | async; as linkableItems) {
  <campus-slideout-modal-stack [activePanel]="activePanel">
    <campus-slideout-modal
      [title]="data.title"
      (animationDone)="slideOutAnimationDone()"
      (scrimClicked)="activePanel = activePanel - 1"
      >
      <campus-slideout-modal-header-actions>
        <dcr-inline-icon-button
          data-cy="sidesheet-close"
          (click)="closed.emit(true)"
          icon="navigation:close"
        ></dcr-inline-icon-button>
      </campus-slideout-modal-header-actions>
      @if (data.context) {
        <dcr-section heading-level="h5" headline="Geselecteerde lesmaterialen" outline="">
          <ol>
            @for (item of data.items; track item) {
              <li>{{ item.label }}</li>
            }
          </ol>
        </dcr-section>
      }
      <ng-container *ngTemplateOutlet="filter"></ng-container>
      <ng-container *ngTemplateOutlet="createCollectionTemplate"></ng-container>
      @if (data.subtitle) {
        <h6 data-cy="sidesheet-subtitle" class="[ p-b-s ]">{{ data.subtitle }}</h6>
      }
      <dcr-divider></dcr-divider>
      <ng-container *ngTemplateOutlet="collection"></ng-container>
      <!-- UI blocks -->
      <ng-template #createCollectionTemplate>
        <div data-cy="manage-collection-new" class="[ flex p-b-s ]">
          <dcr-text-field
            data-cy="manage-collection-new-input"
            class="[ w-full ]"
            [placeholder]="data.createCollectionLabel || 'Nieuwe bundel toevoegen'"
            (input)="updateCollectionName($event.target.value)"
            (change)="updateCollectionName($event.target.value)"
          ></dcr-text-field>
          <dcr-inline-icon-button
            data-cy="manage-collection-new-button"
            icon="content:add"
            [disabled]="!newCollectionName"
            (click)="onCreateCollectionClick(newCollectionName)"
          ></dcr-inline-icon-button>
        </div>
      </ng-template>
      <ng-template #filter>
        @if (useFilter && linkableItems.length > 0) {
          <dcr-text-field
            data-cy="manage-collection-filter"
            type="search"
            [clearable]="true"
            (input)="onFilterValueChange($event.target.value)"
            (clear)="clearFilter()"
            placeholder="Filter"
          ></dcr-text-field>
        }
      </ng-template>
      <ng-template #collection>
        @if (linkableItems.length > 0) {
          <div class="[ stack ][ p-b-s p-i-xs ]">
            @if (!filterValue && recentLinkableItems.length > 0) {
              <div>
                <div data-cy="manage-collection-subheader-recent" class="[ title-small ]">Recent gebruikt</div>
                <div class="[ stack ]">
                  @for (item of recentLinkableItems; track item) {
                    <div class="[ cluster flex gap-m ]">
                      <dcr-checkbox
                        data-cy="manage-collection-recent-item-checkbox"
                        [value]="item.id"
                        [checked]="isItemSelected(item.id)"
                        (change)="onCheckboxChanged($event.target.checked, item.id)"
                        >
                      </dcr-checkbox>
                      <ng-container *ngTemplateOutlet="listItem; context: { listItem: item }"></ng-container>
                    </div>
                  }
                </div>
              </div>
            }
            @if (listItems$ | async; as filteredItems) {
              @if (filteredItems.length) {
                <div class="[ stack ]">
                  <div data-cy="manage-collection-subheader-all" class="[ title-small ]">Alle</div>
                  @for (item of filteredItems; track item) {
                    <div
                      class="[ cluster flex gap-m ]"
                      data-cy="manage-collection-all-list-option"
                      >
                      <dcr-checkbox
                        data-cy="checkbox-manage-collection-all-list-option"
                        [value]="item.id"
                        [checked]="isItemSelected(item.id)"
                        (change)="onCheckboxChanged($event.target.checked, item.id)"
                        >
                      </dcr-checkbox>
                      <ng-container *ngTemplateOutlet="listItem; context: { listItem: item }"></ng-container>
                    </div>
                  }
                </div>
              } @else {
                <div data-cy="manage-collection-no-results-message" class="ui-manage-collection__no-results [ center-items ]">
                  <campus-empty-state
                    [dense]="true"
                    [svgImage]="'empty:' + data.collectionType"
                    title="Het filteren leverde geen resultaten op."
                  ></campus-empty-state>
                  <dcr-tonal-button
                    data-cy="manage-collection-no-results-reset"
                    label="Filter verwijderen"
                    (click)="clearFilter()"
                  ></dcr-tonal-button>
                </div>
              }
            }
          </div>
        } @else {
          <div class="ui-manage-collection__no-results" data-cy="empty-collection-message">
            <campus-empty-state
              [dense]="true"
              [svgImage]="'empty:' + data.collectionType"
              [title]="'Geen ' + data.collectionType"
            ></campus-empty-state>
          </div>
        }
      </ng-template>
      <ng-template #listItem let-item="listItem">
        <div class="[ flex-1 justify-between ]">
          <div data-cy="manage-collection-list-item" class="[ ui-body-1 ]">{{ item.label }}</div>
          @if (item.linkToItem) {
            <dcr-inline-icon-button
              data-cy="sidesheet-open-in-new"
              icon="actions:open_in_new"
              (click)="navigateTo($event, item.linkToItem)"
              [matTooltip]="item.linkToTooltip || 'Ga naar taak detail'"
            ></dcr-inline-icon-button>
          }
        </div>
      </ng-template>
    </campus-slideout-modal>
  </campus-slideout-modal-stack>
}
